export default {
  BLS_UPDATE_CLAIM: 'claim job(s)',
  BLS_UPDATE_RCV_PYMT: 'receive payment(s)',
  BLS_UPDATE_PAYROLL: 'to pay on job(s)'
}
